import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)

type Props = {
    // buttonText: string,
}
export const SkipButton: React.FC<Props> = (props) => {
  const SkipButtonComponent = styled.button`
    color: #1F1F1F;
    margin-top: 30px;
    width: 288px;
    border-radius: 25px;
    height: 37px;
  `;

return (
    <SkipButtonComponent id="skipButton" type="button">今は追加しない</SkipButtonComponent>
  );
};